document.addEventListener('DOMContentLoaded', function() {
  var parentMenuItems = document.querySelectorAll('.header-menu li.menu-item-has-children > a');
  var hamburgerIcon = document.querySelector('.hamburger-icon');
  var mobileMenu = document.querySelector('.mobile-menu');

  parentMenuItems.forEach(function(item) {
    // Add chevron icon to parent items
    var chevronIcon = document.createElement('i');
    chevronIcon.className = 'fa-solid fa-chevron-down';
    item.appendChild(chevronIcon);

    chevronIcon.addEventListener('click', function(e) {
      e.preventDefault();
      var parent = this.parentElement.parentElement;
      parent.classList.toggle('open');

      var submenu = parent.querySelector('ul.sub-menu');
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
    });
  });

  hamburgerIcon.addEventListener('click', function() {
    this.classList.toggle('open');
    mobileMenu.classList.toggle('open');
  });
});
